import { createMapAction } from "chalet-shared";

import { MutePeriod, MuteType } from "../service/Data";

export const actionCreators = {
    muteRoom: createMapAction(
        "MUTE_ROOM",
        (x: { roomId: string; type: MuteType; period: MutePeriod | undefined }) => x
    ),
    unmuteRoom: createMapAction("UNMUTE_ROOM", (roomId: string) => roomId),
};
